import React, { useEffect, useMemo } from 'react'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import Box from '@material-ui/core/Box'

import DeckGLMap from 'components/DeckGLMap'
import LayerManager from 'components/LayerManager'

import useOverlays from 'containers/Dilution/hooks/useOverlays'
import useDischargeOutlets from 'containers/Dilution/hooks/useDischargeOutlets'
import activeModelState from 'containers/Dilution/states/activeModel'
import activeScenarioState from 'containers/Dilution/states/activeScenarioType'
import { mapOverlays } from 'containers/Dilution/states/mapOverlays'
import {
  bathymetryVisibleState,
  bathymetryAvailableState,
  bathymetryImagesState,
} from 'containers/Dilution/states/bathymetry'
import useBitmapLayers from 'hooks/useBitmapLayers'
import useBathymetryImages from 'hooks/useBathymetryImages'
import { HOSTS } from 'config/constants'

import useDampingLayer from './hooks/useDampingLayer'
import useEditLayers from './hooks/useEditLayers'
import EditControl from './hooks/editControl'

import Wizard from './partials/Wizard'

const Form = () => {
  const resetActiveModel = useResetRecoilState(activeModelState)
  const resetMapOverlays = useResetRecoilState(mapOverlays)
  const resetActiveScenario = useResetRecoilState(activeScenarioState)
  const resetBathymetryVisible = useResetRecoilState(bathymetryVisibleState)
  const resetBathymetryAvailable = useResetRecoilState(bathymetryAvailableState)
  const resetBathymetryImages = useResetRecoilState(bathymetryImagesState)

  const bathymetryImages = useRecoilValue(bathymetryImagesState)
  const bathymetryVisible = useRecoilValue(bathymetryVisibleState)

  // mapConnectionId is always "Map" and baseURL is always HOSTS.DILUTION —
  // no scenario result needed; bathymetry is available as soon as a model is selected
  useBathymetryImages({ mapConnectionId: 'Map', baseURL: HOSTS.DILUTION })

  const bathymetryBitmapLayers = useBitmapLayers({
    images: bathymetryVisible ? bathymetryImages : [],
    step: 0,
    id: 'edit-view-bathymetry',
  })

  const editLayers = useEditLayers()
  const geojsons = useDischargeOutlets({ id: 'edit-view' })
  const dampingLayer = useDampingLayer()
  const overlays = useOverlays({ id: 'edit-view' })

  const layers = useMemo(
    () => [
      ...overlays,
      ...bathymetryBitmapLayers,
      geojsons,
      editLayers,
      dampingLayer,
    ],
    [geojsons, editLayers, dampingLayer, overlays, bathymetryBitmapLayers]
  )

  useEffect(() => {
    return () => {
      resetActiveModel()
      resetMapOverlays()
      resetActiveScenario()
      resetBathymetryVisible()
      resetBathymetryAvailable()
      resetBathymetryImages()
    }
  }, [])

  return (
    <>
      <Box width={0.5} height="calc(100vh - 80px)">
        <DeckGLMap layers={layers}>
          <LayerManager />
          <EditControl />
        </DeckGLMap>
      </Box>
      <Box>
        <Wizard />
      </Box>
    </>
  )
}

export default Form
